import { lazy } from "react"

export const AccountMainPage = lazy(() => import("./AccountMainPage"))
